import { uniqueId } from 'lodash';

import { DISMISS_ALERT, SHOW_ALERT } from './constants';
import { makeStandardActionCreator } from 'reducers/action-helpers';

// ACTION CREATORS
const alertCreated = makeStandardActionCreator(SHOW_ALERT);
const alertDismissed = makeStandardActionCreator(DISMISS_ALERT);

/**
  * @param {Object} payload - contains 'message' and 'type' properties.
  * @param {String} payload.message
  * @param {String} payload.type - 'error'(vermelho), 'info'(azul), 'success'(verde), 'warning'(amarelo)
  */
export const showAlert = payload => dispatch => {
  const id = uniqueId('alert_');
  payload.id = id;
  dispatch(alertCreated(payload));

  setTimeout(() => {
    dispatch(alertDismissed({ id }));
  }, 5000);
};

export const dismissAlert = id => dispatch => {
  dispatch(alertDismissed({ id }));
};



// WEBPACK FOOTER //
// ./src/reducers/alerts/actions.js